<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>用户列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form
          ref="queryForm"
          :model="searchForm"
          inline
          label-width="68px"
          style="margin-left: 8vh"
        >
          <el-row>
            <el-col :span="4">
              <el-form-item style="margin-bottom: 0">
                <el-input
                  v-model="searchForm.realname"
                  autocomplete="off"
                  maxlength="30"
                  placeholder="用户名称"
                  clearable
                  size="small"
                  @change="searchChange"
                  @clear="clearInput1"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item style="margin-bottom: 0">
                <el-input
                  v-model="searchForm.mobile"
                  autocomplete="off"
                  maxlength="30"
                  placeholder="用户电话"
                  clearable
                  size="small"
                  @change="searchChange"
                  @clear="clearInput2"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item style="margin-bottom: 0">
                <el-select
                  v-model="searchForm.xiaoqu_id"
                  placeholder="小区名称"
                  clearable
                  size="small"
                  filterable
                  @change="searchChange"
                  @clear="clearInput3"
                >
                  <el-option
                    v-for="item in regionArr"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item style="margin-bottom: 0">
                <el-input
                  v-model="searchForm.id"
                  autocomplete="off"
                  maxlength="30"
                  placeholder="用户ID"
                  clearable
                  size="small"
                  @change="searchChange"
                  @clear="clearInput3"
                />
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item style="margin-bottom: 0">
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="searchChange"
                  size="small"
                  >搜索</el-button
                >

                <!-- <el-button icon="el-icon-refresh" @click="resets" size="mini"
              >重置</el-button
            > -->
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item style="margin-bottom: 0">
                <el-button
                  type="info"
                  icon="el-icon-upload2"
                  @click="postTrue"
                  size="small"
                  >导出</el-button
                >
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item style="margin-bottom: 0">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  @click="batchDels"
                  size="small"
                  >批量删除</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <!-- 分割线 -->
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form
      ref="queryForm"
      :model="searchForm"
      inline
      label-width="68px"
      style="margin-top: 2vh"
    >
      <el-form-item label="用户名称">
        <el-input
          v-model="searchForm.realname"
          autocomplete="off"
          maxlength="30"
          placeholder="请输入"
          clearable
          size="mini"
        />
      </el-form-item>
      <el-form-item label="用户电话">
        <el-input
          v-model="searchForm.mobile"
          autocomplete="off"
          maxlength="30"
          placeholder="请输入"
          clearable
          size="mini"
        />
      </el-form-item>
      <el-form-item label="小区名称">
        <el-select
          v-model="searchForm.xiaoqu_id"
          placeholder="请选择"
          clearable
          size="mini"
        >
          <el-option
            v-for="item in regionArr"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="searchChange"
          size="mini"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" @click="resets" size="mini"
          >重置</el-button
        >
      </el-form-item>
    </el-form> -->
    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      border
      size="medium"
      @selection-change="handleSelectionChanges"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column type="selection" width="55" align="center">
      </el-table-column>
      <el-table-column prop="id" label="用户Id" align="center" />
      <el-table-column prop="realname" label="名称" align="center" />
      <el-table-column prop="mobile" label="电话号码" align="center" />
      <el-table-column prop="xiaoqu_title" label="小区" align="center" />
      <el-table-column
        prop="first_login_time"
        label="首次登录时间"
        align="center"
      />
      <el-table-column prop="recent_time" label="最近登录时间" align="center">
        <template slot-scope="scope">
          {{ formattedTime(scope.row.recent_time) }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="用户详情" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="details(scope.row)"
            type="primary"
            size="small"
            icon="el-icon-tickets"
          >
            详情
          </el-button>
          <el-button
            @click.native.prevent="singleDel(scope.row, scope.row.id)"
            type="danger"
            size="small"
            icon="el-icon-delete"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.pageSize"
      @pagination="initList"
    />
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="95%"
      class="global-dialog-position"
      :before-close="getout"
      top="5vh"
      :lock-scroll="false"
      :append-to-body="true"
    >
      <el-row v-loading="loading">
        <el-col :span="13">
          <h4 class="info-title">用户信息:</h4>
          <el-descriptions class="margin-top" :column="3" size="medium" border>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                用户名
              </template>
              {{ userInfo.realname }}
              <el-button @click="editName" size="mini">修改</el-button>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                手机号
              </template>
              {{ userInfo.mobile }}
              <el-button @click="editPhone" size="mini">修改</el-button>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-office-building"></i>
                停留时间
              </template>
              {{ userInfo.stay_second }}s
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-location-outline"></i>
                登录次数
              </template>
              {{ userInfo.login_times }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-tickets"></i>
                备注
              </template>
              {{ userInfo.content }}
              <el-button @click="editRmark" size="mini">修改</el-button>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-tickets"></i>
                禁用启用小区
              </template>
              <el-switch v-model="isStatusTrue"></el-switch>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-tickets"></i>
                模版消息状态
              </template>
              <el-switch v-model="template_status"></el-switch>
            </el-descriptions-item>
          </el-descriptions>
          <h4 class="info-title">
            小区权限:<el-select
              v-model="xiaoquValue"
              filterable
              placeholder="搜索小区"
              size="small"
              style="margin-left: 2vh"
              @change="selectXiaqou"
              @visible-change="valueChange($event)"
            >
              <el-option
                v-for="item in regions"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </h4>
          <!-- <el-button type="success" @click="allClick">一键全选</el-button> -->

          <div style="display: flex; flex-wrap: wrap; gap: 10px">
            <div
              v-for="(button, index) in regions"
              :key="index"
              style="display: flex; align-items: center; flex-basis: 25%"
            >
              <el-button
                v-model="selectedButton"
                :type="selectedButton === index ? 'primary' : 'default'"
                :plain="selectedButton !== index"
                @click="selectButton(index, button.id)"
                style="flex-grow: 1"
              >
                {{ button.title }}
              </el-button>
              <el-checkbox
                v-model="button.check"
                class="checkbox"
                style="align-self: center"
                @change="handleCheckboxChange(button.id, userInfo.id)"
              ></el-checkbox>
            </div>
          </div>
          <el-divider></el-divider>
          <h4 class="info-title">用户标签:</h4>
          <div style="display: flex; gap: 10px">
            <el-tag
              v-for="(tags, index) in userTag"
              :key="index"
              effect="plain"
              >{{ tags }}</el-tag
            >
          </div>
          <el-divider></el-divider>
          <h4 class="info-title">锁定:</h4>
          <div style="display: flex; gap: 10px; flex-wrap: wrap">
            <el-tag
              v-for="(lock, index) in userLock"
              :key="index"
              effect="plain"
              >{{ lock.carport_title }}</el-tag
            >
          </div>
          <el-divider></el-divider>
          <h4 class="info-title">用户收藏:</h4>
          <div style="display: flex; gap: 10px; flex-wrap: wrap">
            <el-tag
              v-for="(userLikes, index) in userLike"
              :key="index"
              effect="plain"
              >{{ userLikes.carport_title }}</el-tag
            >
          </div>
        </el-col>
        <el-col :span="11">
          <el-timeline>
            <el-timeline-item
              v-for="(item, index) in displayUserFollow"
              :key="index"
              :timestamp="item.created_at"
              placement="top"
            >
              <el-card>
                <h4>
                  购买想法:
                  <span style="color: #409eff">{{ item.intention_tag }}</span>
                </h4>
                <p>
                  <el-row>
                    <el-col :span="12">
                      备注:
                      <span style="color: #e6a23c">{{ item.content }}</span>
                    </el-col>
                    <el-col :span="12">
                      跟进阶段:<span style="color: #e6a23c">{{
                        item.stage_tag
                      }}</span>
                    </el-col>
                  </el-row>
                </p>
                <div style="display: flex; gap: 10px">
                  <el-image
                    v-for="(image, index) in item.imgs"
                    :key="index"
                    style="width: 100px; height: 100px"
                    :src="`${image}`"
                    :preview-src-list="item.imgs"
                  ></el-image>
                </div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
          <!-- 分页 -->
          <el-pagination
            :current-page="currentPage"
            :page-sizes="[3, 6, 9, 12]"
            :total="userFollow.length"
            background
            :page-size="pageSize"
            layout="sizes, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="修改姓名"
      :visible.sync="nameOpen"
      :close-on-click-modal="false"
      width="30%"
      class="nameDag global-dialog-position"
    >
      <el-form ref="nameForm" :model="nameForm" label-width="60px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="姓名">
              <el-input
                v-model="nameForm.realname"
                autocomplete="off"
                placeholder="请输入"
                type="input"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormN">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改备注"
      :visible.sync="remarkOpen"
      :close-on-click-modal="false"
      width="40%"
      class="remarkDag global-dialog-position"
    >
      <el-form ref="userInfoForm" :model="userInfoForm" label-width="60px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                v-model="userInfoForm.content"
                autocomplete="off"
                placeholder="请输入"
                :rows="5"
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForms">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导出弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="postOpen"
      :close-on-click-modal="false"
      width="45%"
      class="postOpen global-dialog-position"
      :before-close="getouts"
      style="margin-top: -10vh"
    >
      <el-form
        ref="xiaoquRule"
        :model="xiaoquForm"
        label-width="150px"
        :rules="xiaoquRule"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="请选择导出小区" prop="xiaoqu_id">
              <el-select
                v-model="xiaoquForm.xiaoqu_id"
                placeholder="小区名称"
                clearable
                size="small"
                filterable
                style="width: 100%"
                @change="xiaoquChange"
                @clear="clearInput3"
              >
                <el-option
                  v-for="item in regionArr"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="请选择注册时间">
              <el-date-picker
                v-model="datePic"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                size="small"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- <el-form
        ref="xiaoquRule"
        :model="xiaoquForm"
        :rules="xiaoquRule"
        label-width="150px"
      > -->
      <!-- <el-form-item
          style="margin-bottom: 0"
          label="请选择导出小区"
          prop="xiaoqu_id"
        >
          <el-select
            v-model="xiaoquForm.xiaoqu_id"
            placeholder="小区名称"
            clearable
            size="small"
            filterable
            style="width: 100%"
            @change="xiaoquChange"
            @clear="clearInput3"
          >
            <el-option
              v-for="item in regionArr"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
      <!-- <el-form-item label="请选择导出楼层" prop="floor_id">
          <el-select
            v-model="floorId.floor_id"
            placeholder="请选择"
            clearable
            style="width: 100%"
            size="mini"
          >
            <el-option
              v-for="item in floorArr"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
      <!-- </el-form> -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="postSubmit">确定导出</el-button>
        <el-button @click="getouts">取 消</el-button>
      </div>
    </el-dialog>
    <div class="block" style="width: 100%"></div>
  </div>
</template>

<script>
import tableCommon from "../../../mixins/table-common";
import { getCookie } from "../../utils/util";

import { editCity } from "../../api/city";
import { getcommunityList } from "../../api/community";
import axios from "axios";

import {
  editContent,
  getmembersListInfo,
  getmemberInfo,
  editmemberPower,
  editmemberMake,
  editmobanMake,
  deletePeople,
  editPhone,
  editName,
} from "../../api/member";
export default {
  mixins: [tableCommon],
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      rules: [],
      currentPage: 1,
      pageSize: 3,
      timelineData: [
        {
          timestamp: "2018/9/16",
          title: 1,
          author: 1,
        },
        {
          timestamp: "2018/9/17",
          title: 1,
          author: 1,
        },
      ],
      value: true,
      selectedButton: 0,
      loading: true,
      // 请求地址api
      api: {
        list: getmembersListInfo,
        del: deletePeople,
      },
      // 传参
      form: {},
      datePic: "",
      // 弹窗
      addOrEditOpen: false,
      // 标签
      title: "",
      detePic: "",
      // 查询参数
      searchForm: {
        page: 1,
        pageSize: 15,
      },
      // 用户信息列表
      userInfo: {},
      // 小区列表
      regions: [],
      // 用户标签
      userTag: "",
      // 用户收藏
      userLike: [],
      // 用户跟进
      userFollow: [],
      // 用户id
      userId: "",
      // 用户锁定
      userLock: [],
      // 小区id
      regionArr: [],
      xiaoqu_userId: "",
      userForms: {},
      //备注弹窗
      remarkOpen: false,
      userInfoForm: {},
      xiaoquValue: "",
      // 导出弹窗
      postOpen: false,
      xiaoquForm: {},
      postTitle: "",
      // 姓名表单
      nameForm: {},
      // 姓名显隐
      nameOpen: false,
      // 上传头文件
      headers: {
        Authorization: "Bearer " + getCookie("logintoken"),
      },
      // 导出地址
      exportUrl: process.env.VUE_APP_URL + "/admin/members/export",
      xiaoquRule: {
        xiaoqu_id: [
          { required: true, message: "请选择导出小区", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    displayUserFollow() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.userFollow.slice(startIndex, endIndex);
    },
    isStatusTrue: {
      get() {
        return this.userInfo.status == 1 ? true : false;
      },
      set(value) {
        this.userInfo.status = value ? 1 : 0;
        const makeForm = {
          id: this.userId,
        };
        editmemberMake(makeForm).then((res) => {});
      },
    },
    template_status: {
      get() {
        console.log(this.userInfo);
        return this.userInfo.template_status == 1 ? true : false;
      },
      set(value) {
        this.userInfo.template_status = value ? 1 : 0;
        // const makeForm = {
        //   id: this.userId,
        // };
        this.userInfo.id = this.userId;
        console.log(this.userInfo);
        editmobanMake(this.userInfo).then((res) => {});
      },
    },
  },
  mounted() {
    const form = {
      select: 1,
    };
    getcommunityList(form).then((res) => {
      this.regionArr = res.data.records;
    });
    this.selectButton(0); // 默认选中第一个按钮
  },
  methods: {
    handleSelectionChanges(selection) {
      console.log(selection);
      this.tableSelected = selection;
      this.ids = selection.map((item) => item[this.idKey]);
      console.log(this.ids);
    },
    batchDels() {
      this.batchDel(this.ids);
    },
    async batchDel(idKeys, ...args) {
      const delFn = this.api.del;
      const text = args.length ? `是否删除这条数据` : `是否删除这条数据`;
      await this.$confirm(text, "删除数据", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        for (const idKey of idKeys) {
          console.log(idKey);
          const res = await delFn(idKey);
          if (res.code !== 200) {
            return this.$message.error(res.msg ? res.msg : "删除失败!");
          }
          this.initList();
        }
      });
    },
    xiaoquChange(e) {
      const result = this.regionArr.find((item) => item.id === e);
      this.postTitle = result.title;
      // 输出结果
    },
    // 关闭导入导出
    getouts() {
      this.xiaoquForm = {
        xiaoqu_id: undefined,
      };
      this.$nextTick(() => {
        this.postOpen = false;
        this.datePic = undefined;
        this.$refs.xiaoquRule.clearValidate();
      });
    },
    // 导出
    postTrue() {
      this.title = "导出";
      this.datePic = undefined;
      this.xiaoquForm = {
        xiaoqu_id: undefined,
      };

      this.$nextTick(() => {
        this.postOpen = true;
        this.$refs.xiaoquRule.clearValidate();
      });
    },
    postSubmit() {
      this.$refs["xiaoquRule"].validate((valid, err) => {
        if (valid) {
          console.log(this.datePic);
          if (this.datePic) {
            this.filePut(this.datePic);
          } else {
            this.filePut();
          }
        }
      });
    },
    filePut(res) {
      return axios({
        // 用axios发送get请求
        url: this.exportUrl, // 请求地址
        params: {
          xiaoqu_id: this.xiaoquForm.xiaoqu_id,
          start_time: res ? res[0] : undefined,
          end_time: res ? res[1] : undefined,
        }, // 参数
        method: "get",
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getCookie("logintoken"),
        },
      })
        .then((res) => {
          console.log(res);
          const fileName = `${this.postTitle}用户名单`;
          // 处理返回的文件流
          /* 兼容ie内核，360浏览器的兼容模式 */
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
          });
          /* 兼容ie内核，360浏览器的兼容模式 */
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            /* 火狐谷歌的文件下载方式 */
            let url1 = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url1;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            // console.log(link);
            link.click();
          }
          this.$message.success("成功");
          this.postOpen = false;
          return Promise.resolve(res.data);
        })
        .catch((err) => {
          this.$message.error("失败");
          return Promise.resolve(err);
        });
    },
    async valueChange(e) {
      console.log(e);
      if (e == true) {
        await getmemberInfo(this.userForms).then((res) => {
          if (res.code !== 200) return this.$message.error("请求失败");
          this.regions = res.data.xiaoqus;
        });
      }
    },
    // 选择小区
    async selectXiaqou(e) {
      const filteredRegions = this.regions.filter((item) => item.id === e);
      this.regions = filteredRegions;
    },
    // 全选
    allClick() {
      console.log(this.regions);
    },
    submitForms() {
      const form = {
        id: this.userInfo.id,
        content: this.userInfoForm.content,
      };
      editContent(form).then((res) => {
        if (res.code !== 200) return this.$message.error("修改失败!");
        this.$message.success("修改成功");
        this.remarkOpen = false;
        this.userInfo = res.data;
      });
      console.log(this.userInfoForm.content);
    },
    submitFormN() {
      const form = {
        id: this.nameForm.id,
        realname: this.nameForm.realname,
      };
      editName(form).then((res) => {
        if (res.code !== 200) return this.$message.error("修改失败!");
        this.$message.success("修改成功");
        this.nameOpen = false;
        this.userInfo = res.data;
      });
      console.log(form);
    },
    editRmark() {
      this.userInfoForm = JSON.parse(JSON.stringify(this.userInfo));
      this.remarkOpen = true;
    },
    editName() {
      this.nameForm = JSON.parse(JSON.stringify(this.userInfo));
      this.nameOpen = true;
      console.log(this.nameForm);
    },
    editPhone() {
      this.$prompt("请输入电话号码", "修改", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        // inputErrorMessage: "邮箱格式不正确",
      })
        .then(async ({ value }) => {
          console.log(value);
          const form = {
            id: this.userInfo.id,
            mobile: value,
          };
          editPhone(form).then((res) => {
            if (res.code !== 200) return this.$message.error("修改失败!");
            console.log(this.userForms);
            getmemberInfo(this.userForms).then((res) => {
              if (res.code !== 200) return this.$message.error("请求失败");
              this.userInfo = res.data.member;
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    formattedTime(e) {
      var timestamp = e;
      var date = new Date(timestamp * 1000);
      var year = date.getFullYear();
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      var hours = ("0" + date.getHours()).slice(-2);
      var minutes = ("0" + date.getMinutes()).slice(-2);

      return year + "-" + month + "-" + day + " " + hours + ":" + minutes;
    },
    // 点击清空事件
    clearInput1() {
      this.searchForm.realname = undefined;
      this.initList();
    },
    clearInput2() {
      this.searchForm.mobile = undefined;
      this.initList();
    },
    clearInput3() {
      this.searchForm.id = undefined;
      this.initList();
    },
    clearInput3() {
      this.searchForm.xiaoqu_id = undefined;
      this.initList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    // 选中小区
    handleCheckboxChange(res, req) {
      const checkData = {
        id: req,
        xiaoqu_id: res,
      };
      editmemberPower(checkData).then((res) => {});
    },
    selectButton(index, id) {
      this.selectedButton = index;
      if (id) {
        const regionForm = {
          xiaoqu_id: id,
          id: this.userId,
        };
        this.details(regionForm);
      }
    },
    //查看详情
    details(req) {
      this.title = "详情";
      this.userId = req.id;
      this.userForms = req;
      this.addOrEditOpen = true;
      getmemberInfo(req).then((res) => {
        if (res.code !== 200) return this.$message.error("请求失败");
        this.userInfo = res.data.member;
        this.regions = res.data.xiaoqus;
        this.userTag = res.data.tag;
        this.userLike = res.data.sc;
        this.userFollow = res.data.follow.reverse();
        this.userLock = res.data.lock;
        this.xiaoqu_userId = res.data.xiaoqu_id;
        let index = this.regions.findIndex(
          (item) => item.id === parseInt(this.xiaoqu_userId)
        );
        this.selectButton(index);
        setTimeout(() => {
          this.loading = false;
        }, 300);
      });
    },
    getout() {
      this.addOrEditOpen = false;
      this.selectButton(0); // 默认选中第一个按钮
      this.xiaoquValue = "";
      this.loading = true;
    },
    resets() {
      this.searchForm = {
        realname: undefined,
        mobile: undefined,
      };
      this.initList();
    },
  },
};
</script>
<style scoped>
/* @font-face {
  font-family: "Barlow Condensed";
  src: url("BarlowCondensed-Bold.woff2") format("woff2"),
    url("BarlowCondensed-Bold.woff") format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
} */
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: "Barlow Condensed";
  /* font-weight: 600; */
}

@font-face {
  font-family: "Barlow Condensed";
  src: url("https://pic.tfw2020.com/font/font.css") format("woff2");
  /* 也可以使用绝对路径引入字体文件
   * src: url(/path/to/fonts/font.woff2) format('woff2');
   */
}

.navFormWrapper {
  display: flex;
  align-items: center;
}

.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.checkbox {
  zoom: 280%;
  margin: -2px 0 0 1px;
}

/deep/ .el-dialog__body {
  height: 75vh;
  overflow-y: auto;
}

/deep/ .remarkDag .el-dialog__body {
  height: 30vh;
  overflow-y: auto;
}
/deep/ .nameDag .el-dialog__body {
  height: 10vh;
  overflow-y: auto;
}
/deep/ .postOpen .el-dialog__body {
  height: 20vh;
  overflow-y: auto;
}
.info-title {
  font-family: "Hiragino Sans GB";
  font-weight: bold;
  /* 设置字体粗细 */
  color: #333;
  /* 设置字体颜色 */
}

/deep/.el-loading-mask {
  top: 20%;
}

/deep/ .el-dialog__body {
  height: 72vh;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/member/memberList.vue